import React, {Component} from 'react';
import {Container, Table} from "reactstrap";
import AppActions from './../actions/AppActions';
import {get} from './../lib/http';
import PlacementMode from "../lib/PlacementMode";
import _ from 'lodash';
import Pager from "./Pager";
import {Link} from "react-router-dom";

const pageSize = 20;

export class Items extends Component {
    componentWillMount() {
        const {skip} = this.props;

        this.update(skip || 0);
    }

    render() {
        const {items, total, skip} = this.props;

        const rows = _.map(items, item => <tr key={item.id}>
            <td>{item.id}</td>
            <td>{item.type}</td>
            <td>{item.description}</td>
            <td>{item.positionX}, {item.positionY}, {item.positionZ}</td>
            <td>{item.scaleX}, {item.scaleY}, {item.scaleZ}</td>
            <td>{item.rotationX}, {item.rotationY}, {item.rotationZ}</td>
            <td>{PlacementMode.nameOfEnumValue(item.placementMode)}</td>
            <td>{item.layer}</td>
            <td>
                <Link className="float-right" to={`item/${item.id}`}>Edit</Link>
            </td>
        </tr>);

        const mixId = window.localStorage.getItem('mixId') || '';

        return (
            <Container fluid>
                <h1>Items</h1>

                <p>https://{window.location.host}/api/data/{mixId}</p>

                <a className="float-right" href={`https://mixiply.com/app/mix/${mixId}`} rel="noopener noreferrer" target="_blank">Mix
                    id: {mixId}</a>
                <div className="clearfix"/>
                <Table size="sm" hover className="mt-3">
                    <thead>
                    <tr>
                        <th>Id</th>
                        <th>Type</th>
                        <th>Description</th>
                        <th>Position</th>
                        <th>Scale</th>
                        <th>Rotation</th>
                        <th>Placement mode</th>
                        <th>Layer</th>
                        <th className="btn-col">&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                    {rows}
                    </tbody>
                    <tfoot>
                    <tr>
                        <td colSpan={8}></td>
                        <td><Link className="float-right" to={'item/_'}>New</Link></td>
                    </tr>
                    </tfoot>
                </Table>

                <Pager pageSize={pageSize} total={total} skip={skip} onPageSelected={(skip) => this.update(skip)}/>
            </Container>
        );
    }

    update(skip) {
        const mixId = window.localStorage.getItem('mixId') || '';

        get('api/items', {skip: skip, mixId}, (data) => {
            AppActions.updateStates([
                {statePath: 'skip', data: skip || 0},
                {statePath: 'items', data: data.items},
                {statePath: 'total', data: data.total}
            ]);
        });
    }
}